/* Source: src/mt-includes/js/src/live_chat/init.js*/
angular.module('website.LiveChat', [
    'website.core.utils',
    'website.LiveChat.settings'
]);
